var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"badge") : depth0)) != null ? lookupProperty(stack1,"Information") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":8,"column":7}}})) != null ? stack1 : "");
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"badge-information "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"badge") : depth0)) != null ? lookupProperty(stack1,"InformationBackgroundColor") : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"badge") : depth0)) != null ? lookupProperty(stack1,"InformationFontFamily") : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"badge") : depth0)) != null ? lookupProperty(stack1,"InformationTextColor") : stack1), depth0))
    + "\"\r\n    data-badge-rank=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"badge") : depth0)) != null ? lookupProperty(stack1,"Rank") : stack1), depth0))
    + "\" data-badge-name=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"badge") : depth0)) != null ? lookupProperty(stack1,"Name") : stack1), depth0))
    + "\">\r\n    <span class=\"info-tab "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"badge") : depth0)) != null ? lookupProperty(stack1,"BckgroundColor") : stack1), depth0))
    + "\"></span>\r\n    <span>"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"badge") : depth0)) != null ? lookupProperty(stack1,"Information") : stack1), depth0))
    + "</span>\r\n</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"badge") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":9,"column":7}}})) != null ? stack1 : "");
},"useData":true});